import Vue from "vue";
import axios from "axios";
import VueCookies from "vue-cookies";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
const ls = new SecureLS({ isCompression: false, encodingType: "aes" });
Vue.use(VueCookies);
Vue.use(Vuex);
const cookiesConfig = {
  expires: "1d",
  secure: true,
};
import gbfEncoder from "@/components/function/encode.js";

let signature = window.localStorage.getItem("signature");
// ! Step
// ! 1 create a state
// ! 2 create a method at action
// ! 3 update a data after request at mutation
// ! 4 set a parameter for call a state at getters
export default new Vuex.Store({
  state: {
    payment: null,
    signature: signature ? JSON.parse(signature) : [],

    // ! ต้องใส่ persistance ด้วย
    state_authorize: false,
    state_user: {},
    // ! เก็บค่าตอนเปลี่ยน tab ระหว่างส่งแล้วกับฉบับร่าง
    state_mainTab: 0,
    // ! สลับเปลี่ยน branch หรือ เปลี่ยนข้อมูลทั้งหมดของ branch
    state_biz: {},
  },
  // ! change state
  mutations: {
    setPayment(state, data) {
      state.payment = data;
    },

    setSignature(state, data) {
      state.signature = data;

      this.commit("saveSignature");
    },

    saveSignature(state) {
      window.localStorage.setItem("signature", JSON.stringify(state.signature));
    },
    logout(state) {
      state.state_authorize = false;
      state.state_user = {};
      state.state_biz = {};
    },
    login_fail(state) {
      state.state_authorize = false;
      state.state_user = {};
    },
    login_sso_success(state, payload) {
      state.state_authorize = true;

      const bizId = payload.bizId;

      const selectedBiz = payload.message.biz_detail.find(
        (item) => item.biz_id === bizId,
      );

      if (!selectedBiz) {
        console.warn("Biz not found:", bizId);
        return;
      }

      const getbiz = selectedBiz.getbiz?.[0] || {};
      const email = payload.email?.[0]?.email || "";

      console.log(getbiz);

      state.state_user = {
        acc_one_id: selectedBiz.account_id || "",
        tax_id: getbiz.id_card_num || "",
        branch_id: getbiz.bracnh || "",
        biz_name_th: getbiz.name_th || "",
        biz_id: selectedBiz.biz_id || "",
        username: payload.username || "",
        email: email,
        accessToken: payload.accessToken || "",
        bizs: payload.message.biz_detail.map(
          (item) => item.getbiz?.[0]?.bracnh,
        ),
      };

      // set default branch จาก biz ที่เลือก
      state.state_biz = {
        branch: getbiz.bracnh || "00000",
      };
    },
    login_success(state, data) {
      state.state_authorize = true;
      console.log("data", data);
      // ! ถ้าใช้เยอะเอาทั้งหมด แต่ต้องแก้ตัวแปรใน payload ทั้งหมด
      // state.state_user = data.biz_detail[0];
      // ! เอาแค่บางตัว
      state.state_user = {
        acc_one_id: data.biz_detail[0].account_id,
        tax_id: data.biz_detail[0].getbiz[0].id_card_num || "",
        branch_id: data.biz_detail[0].getbiz[0].bracnh || "",
        biz_name_th: data.biz_detail[0].getbiz[0].name_th || "",
        biz_id: data.biz_detail[0].biz_id || "",
        username: data.username || "",
        email: data.email[0].email || "",
        accessToken: data.accessToken || "",
        bizs:
          data.biz_detail.length > 1
            ? data.biz_detail.map((bracnh) => {
                return bracnh.getbiz[0].bracnh;
              })
            : data.biz_detail[0].getbiz[0].bracnh,
      };
      // ! set default branch
      state.state_biz = {
        branch: data.biz_detail[0].getbiz[0].bracnh || "00000",
      };
    },
    change_mainTab(state, data) {
      state.state_mainTab = data;
    },
    set_branch_active(state, data) {
      // ทำเพื่อไว้ถ้าเปลี่ยน branch แล้วข้อมูลบางอย่างเดียวเช่นที่อยู่ ก็ให้มาเพิ่มในนี้
      state.state_biz = {
        branch: data,
      };
    },
  },
  // ! Do something
  actions: {
    // ! login Access token
    async login_accesstoken({ commit }, data) {
      let data_return = {};
      try {
        let payload = {
          accessToken: data.accesstoken,
        };

        const payload_encoded = await gbfEncoder.encodeBodyRequest(payload);
        const header_request = { headers: payload_encoded.header };

        const call_api = await axios.post(
          process.env.VUE_APP_API_FACTORING_SELLER + "/profile/getProfile",
          payload_encoded.body,
          header_request,
        );

        // console.log(call_api)
        const response_api = await gbfEncoder.decodeResponse(call_api);

        if (response_api.status === "OK") {
          // console.log("response_api", response_api);
          Vue.$cookies.set("auth", true, cookiesConfig);
          const result = {
            message: response_api.message,
            bizId: data.bizId,
          };
          commit("login_sso_success", result);
          data_return = { status: "OK", errorMessage: "" };
        }
      } catch (error) {
        console.log("error in login_accesstoken", error);
        data_return = {
          status: "ER",
          errorMessage:
            error.response.data.errorMessage || error.request || error,
        };
      }

      return data_return;
    },
    // ! login เข้าสู่ระบบ
    async login_authen({ commit }, data) {
      let data_return = {};
      try {
        let payload = {
          username: data.username,
          password: data.password,
          taxid: data.taxId,
        };
        const call_api = await axios.post(
          process.env.VUE_APP_API_FACTORING_IBILL + "/login/loginByPWD",
          payload,
        );

        if (call_api.data.status === "OK") {
          // console.log("call api", call_api);
          Vue.$cookies.set("auth", true, cookiesConfig);
          // ! commit to login success
          commit("login_success", call_api.data.message);
          data_return = { status: "OK", errorMessage: "" };
        } else {
          // ! commit to login fail
          commit("login_fail");
          data_return = {
            status: "ER",
            errorMessage: call_api.data.errorMessage,
          };
        }
      } catch (error) {
        console.log("error in login_authen", error);
        data_return = {
          status: "ER",
          errorMessage:
            error.response.data.errorMessage || error.request || error,
        };
      }
      // ! return
      return new Promise((res) => {
        res(data_return);
      });
    },
    logout_authen({ commit }) {
      Vue.$cookies.remove("auth");
      commit("logout");
    },
    // ! ตั้งค่า mainTab ไม่ได้เรียกไปเรียกที่ mutation เลยได้
    // change_mainTab({ commit }, data) {
    //   commit("action change_mainTab", data);
    // },
    switch_branch({ commit }, data) {
      // เปลี่ยน  branch จาก dropdown จะต้องให้ $store.dispatch ('switch_branch',_branch)มา
      const branch = data || "00000";
      commit("set_branch_active", branch);
    },
  },
  getters: {
    getPayment: (state) => {
      return state.payment;
    },
    getSignature: (state) => {
      return state.signature;
    },
    // ! ยังไม่ใช่ของจริง
    gettersAuthorize: (state) => {
      return state.state_authorize;
    },
    getterUser: (state) => {
      return state.state_user;
    },
    // ! เรียกใช้งานค่าที่เก็บ mainTab
    getterMainTab: (state) => {
      return state.state_mainTab;
    },
    // เรียกใช้ branch ตอนยิง api
    getterActiveBranch: (state) => {
      return state.state_biz.branch;
    },
  },

  plugins: [
    createPersistedState({
      key: "ibillingPersistedState",
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    }),
  ],
});
